/* Arjit4Amply: continuous auto-scroll for the testimonial mosaic, ported
   directly from Handover_Package/reference-site/app.js's communityCarousel
   logic - pauses on mouse hover, keyboard focus, and touch, resumes on
   release, respects prefers-reduced-motion, and only runs while the
   element is actually on screen (IntersectionObserver). Loops seamlessly
   by resetting scrollLeft by exactly one .matre-testimonials__group's width
   once scrolled past it, rather than a CSS animation - matches the
   reference's own technique so the two rendered groups (real + aria-hidden
   "repeat") tile without a visible seam. */
(function () {
  document.querySelectorAll('[data-mosaic]').forEach(initMosaic);

  function initMosaic(mosaic) {
    var motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
    var hovered = false, focused = false, touching = false;
    var visible = false, frame = 0, lastTime = 0, position = 0;

    function loopWidth() {
      var group = mosaic.querySelector('.matre-testimonials__group');
      return group.offsetWidth + parseFloat(getComputedStyle(mosaic).gap);
    }

    function canMove() {
      return visible && !hovered && !focused && !touching && !document.hidden && !motionPreference.matches;
    }

    function tick(time) {
      frame = 0;
      if (!canMove()) {
        lastTime = 0;
        return;
      }
      if (lastTime) {
        position += Math.min(time - lastTime, 50) * 0.036;
        var width = loopWidth();
        if (position >= width) position -= width;
        mosaic.scrollLeft = position;
      }
      lastTime = time;
      frame = requestAnimationFrame(tick);
    }

    function resume() {
      if (canMove() && !frame) {
        position = mosaic.scrollLeft;
        lastTime = 0;
        frame = requestAnimationFrame(tick);
      }
    }

    mosaic.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') hovered = true;
    });
    mosaic.addEventListener('pointerleave', function () {
      hovered = false;
      resume();
    });
    mosaic.addEventListener('focusin', function () {
      focused = mosaic.matches(':focus-visible');
    });
    mosaic.addEventListener('focusout', function () {
      focused = false;
      resume();
    });
    mosaic.addEventListener('pointerdown', function (e) {
      focused = false;
      if (e.pointerType !== 'mouse') touching = true;
    });

    function releaseTouch() {
      if (!touching) return;
      touching = false;
      resume();
    }

    window.addEventListener('pointerup', releaseTouch);
    window.addEventListener('pointercancel', releaseTouch);
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      resume();
    }).observe(mosaic);
    document.addEventListener('visibilitychange', resume);
    motionPreference.addEventListener('change', resume);
  }
})();
